import { useState, useEffect } from "react"

function usePages(data, itemsPerPage) {
  const [currentPage, setCurrentPage] = useState(0)
  const [currentTheme, setCurrentTheme] = useState(0)
  const dataStart = currentPage * itemsPerPage

  const currentData = data.slice(dataStart, dataStart + itemsPerPage)

  const maxPages = Math.ceil(data.length / itemsPerPage)

  const clickHandlerRightSlide = () => {
    const maxPages = Math.ceil(data.length / itemsPerPage)
    currentPage + 1 === maxPages
      ? setCurrentPage(0)
      : setCurrentPage(currentPage + 1)
  }

  const clickHandlerRightLeftSlide = () => {
    currentPage === 0 ? setCurrentPage(4) : setCurrentPage(currentPage - 1)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentPage + 1 < maxPages) {
        setCurrentPage(currentPage + 1)
      } else {
        setCurrentPage(0)
      }
    }, 6000)
    return () => {
      clearInterval(interval)
    }
  })

  useEffect(() => {
    if (data[currentPage].theme) {
      setCurrentTheme(data[currentPage].theme)
    }
  }, [currentPage])

  return {
    currentData,
    currentPage,
    currentTheme,
    maxPages,
    setCurrentPage,
    clickHandlerRightSlide,
    clickHandlerRightLeftSlide,
  }
}

export default usePages
